// extracted by mini-css-extract-plugin
export default {"root":"RobotHistory_root__y2cbN","tableWrapper":"RobotHistory_tableWrapper__gg6Ec"};